import { Mail, MessageCircle } from "lucide-react";
import type { Invio } from "@/api/preventivo";
import { INVII, rigaInvio } from "./scritteLista";

/** Il registro degli invii all'amministratore (spec § 7), dal più recente; senza invii non c'è. Il registro resta anche
 *  dopo la scadenza del link: lo scaduto è scritto a parole («scaduto il 20/11»), non solo più chiaro. */
export function Invii({ invii }: { invii: Invio[] }) {
  if (invii.length === 0) return null;
  const ordinati = [...invii].sort((a, b) => Date.parse(b.il) - Date.parse(a.il));
  return (
    <section className="rounded-lg border border-border bg-card p-4 text-sm sm:max-w-xl">
      <h3 className="font-heading text-base font-semibold text-text">{INVII}</h3>
      <ul className="mt-2 space-y-2">
        {ordinati.map((i) => {
          const Icona = i.canale === "mail" ? Mail : MessageCircle;
          return (
            <li key={`${i.canale}-${i.il}`} className={`flex gap-2 ${i.scaduto ? "text-muted-foreground" : "text-text"}`}>
              <Icona size={16} aria-hidden="true" className="mt-0.5 shrink-0" />
              <span className="min-w-0 break-words">{rigaInvio(i)}</span>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
